import {
  SelfOnboardingStepKey,
  useGetSelfOnboardingCurrentStepLazyQuery,
} from 'apollo/generated/client-operations';

export function useGetIsSelfOnboardingClosed(): {
  isSelfOnboardingClosed: () => Promise<boolean>;
} {
  const [fetchIsSelfOnboardingClosed] =
    useGetSelfOnboardingCurrentStepLazyQuery({
      fetchPolicy: 'network-only',
    });

  const isSelfOnboardingClosed = async (): Promise<boolean> => {
    const { data } = await fetchIsSelfOnboardingClosed();
    return (
      data?.getCurrentSession.user.worker.selfOnboardingCurrentStep ===
      SelfOnboardingStepKey.Closed
    );
  };

  return { isSelfOnboardingClosed };
}
